/**
 * @generated SignedSource<<439626f9e1ed89bb171588f06de2a9b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecordingMediaType = "AUDIO" | "VIDEO";
export type RecordingMode = "BOT" | "BOTLESS";
export type PreMeetingControls_setSettingMutation$variables = {
  setting: string;
  streamId: string;
  value?: string | null;
};
export type PreMeetingControls_setSettingMutation$data = {
  readonly noteStreamSetting: {
    readonly stream: {
      readonly id: string;
      readonly recordingMediaType: RecordingMediaType;
      readonly recordingMode: RecordingMode;
    };
  } | null;
};
export type PreMeetingControls_setSettingMutation = {
  response: PreMeetingControls_setSettingMutation$data;
  variables: PreMeetingControls_setSettingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setting"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "setting",
        "variableName": "setting"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "NoteStreamSettingsMutation",
    "kind": "LinkedField",
    "name": "noteStreamSetting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recordingMediaType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recordingMode",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PreMeetingControls_setSettingMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PreMeetingControls_setSettingMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "fa6e838bff9323b8d0401036b17670a7",
    "id": null,
    "metadata": {},
    "name": "PreMeetingControls_setSettingMutation",
    "operationKind": "mutation",
    "text": "mutation PreMeetingControls_setSettingMutation(\n  $streamId: ID!\n  $setting: String!\n  $value: String\n) {\n  noteStreamSetting(streamId: $streamId, setting: $setting, value: $value) {\n    stream {\n      id\n      recordingMediaType\n      recordingMode\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ff843b1433dd42ba3b83aa2b88fc849";

export default node;
